// Helpers PUROS de navegação/mutação do cache de tarefas do store
// (`state.tasks` + `state.taskDetail`). Extraídos das mutations para manter
// mutations.js focado nas mutations; a lógica reutilizável de localização e de
// aplicação de anexos vive aqui (review #1352).

// Localiza um comentário de uma tarefa pelo id. Retorna o comentário ou null.
// Compartilhado pelas mutations de anexo de comentário.
export function findComment(state, taskId, commentId) {
  const task = state.tasks.find(function (t) {
    return t.id === taskId
  })
  if (!task || !task.comments) return null
  return (
    task.comments.find(function (c) {
      return c.id === commentId
    }) || null
  )
}

// Percorre tarefas top-level e quaisquer `subtarefas` aninhadas para achar o nó
// que casa com `taskId` e aplica `mutate(node)`. Faz splice do nó (e da cadeia
// de pais) para o Vue 2 detectar a mudança sem `$set`. Retorna true quando a
// tarefa é encontrada no cache.
export function walkTaskAndMutate(list, taskId, mutate) {
  if (!Array.isArray(list) || !list.length) return false
  for (let i = 0; i < list.length; i++) {
    const node = list[i]
    if (!node) continue
    if (node.id === taskId) {
      const merged = { ...node }
      mutate(merged)
      list.splice(i, 1, merged)
      return true
    }
    if (walkTaskAndMutate(node.subtarefas, taskId, mutate)) {
      list.splice(i, 1, { ...node })
      return true
    }
  }
  return false
}

// Adiciona os anexos recebidos a um nó de tarefa e mantém `attachmentsCount` em
// sincronia.
export function applyAddAttachments(node, attachments) {
  const incoming = attachments || []
  const current = Array.isArray(node.attachments) ? node.attachments.slice() : []
  for (const att of incoming) {
    if (att) current.push(att)
  }
  node.attachments = current
  node.attachmentsCount = current.length
}

// Remove um anexo de um nó de tarefa e mantém `attachmentsCount` em sincronia.
export function applyRemoveAttachment(node, attachmentId) {
  const current = Array.isArray(node.attachments) ? node.attachments : []
  const filtered = current.filter(function (a) {
    return !a || a.id !== attachmentId
  })
  node.attachments = filtered
  // Decrementa a contagem mesmo quando a lista de anexos não foi carregada
  // neste nó cacheado (ex.: nós de listagem só carregam a contagem, não o array).
  if (filtered.length !== current.length) {
    node.attachmentsCount = filtered.length
  } else if (typeof node.attachmentsCount === 'number' && node.attachmentsCount > 0) {
    node.attachmentsCount = node.attachmentsCount - 1
  }
}
